import React from "react";
import _ from "lodash";

import DesignItemList from "./DesignItemList";
import DesignItem from "./DesignItem";
import DesignPageList from "./DesignPageList";
import DesignBlockList from "./DesignBlockList";

const DesignChildren = ({ design, showSiteBlocks, showPageBlocks, selected, onItemClick }) => {
  const pages = _.get(design, "pages", []);
  const wppages = _.get(design, "wppages", []);
  const blocks = _.get(design, "blocks", []);
  const { id } = design;

  const items = [];

  if (showSiteBlocks && _.size(blocks) > 0) {
    items.push(
      <DesignBlockList
        key={`${id}-site-blocks`}
        blocks={blocks}
        selected={selected}
        onItemClick={onItemClick}
        label="Site Canvases"
      />
    );
  }

  if (_.size(pages) > 0) {
    items.push(
      <DesignPageList
        key={`${id}-pages`}
        pages={pages}
        label="Pages"
        onItemClick={onItemClick}
        showBlocks={showPageBlocks}
        selected={selected}
      />
    );
  }

  if (_.size(wppages) > 0) {
    items.push(
      <DesignPageList
        key={`${id}-wppages`}
        pages={wppages}
        label="Blog Templates"
        onItemClick={onItemClick}
        showBlocks={showPageBlocks}
        selected={selected}
      />
    );
  }

  return (
    <DesignItemList key={`${id}-items`} active level={1}>
      {items}
    </DesignItemList>
  );
};

const DesignList = ({
  selected,
  onItemClick,
  showSiteBlocks,
  showPageBlocks,
  designs,
  label,
  loading,
}) => {
  const _onItemClick = (page) => {
    onItemClick(page);
  };

  const icons = "glyphicon glyphicon-global";

  const selectedId = _.get(selected, "site_id", false);
  const items = [];

  designs.forEach((design) => {
    const { id, name } = design;

    items.push(
      <DesignItem
        key={`${id}-${name}`}
        label={name}
        iconClasses={icons}
        active={id === selectedId}
        onClick={() => _onItemClick(design)}
      />
    );

    if (id === selectedId) {
      items.push(
        <DesignChildren
          key={`${id}-${name}-children`}
          {...{ design, showSiteBlocks, showPageBlocks, selected, onItemClick }}
        />
      );
    }
  }, this);

  return (
    <DesignItemList label={label} loading={loading}>
      {items}
      {items.length === 0 && <p style={{ textAlign: "center" }}>No designs added.</p>}
    </DesignItemList>
  );
};

DesignList.defaultProps = {
  showSiteBlocks: true,
  showPageBlocks: true,
};

export default DesignList;
